import { getBtcPrice } from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { web3Api } from 'store/web3Api';

export const { useGetBtcPriceQuery } = web3Api.injectEndpoints({
  endpoints: build => ({
    getBtcPrice: build.query<number, void>({
      queryFn: queryFnNotifyWrapper<void, never, number>(
        async () => {
          return { data: await getBtcPrice() };
        },
        error => getExtendedErrorText(error, 'Unable to get BTC price'),
      ),
    }),
  }),
});
